<h2 class="mbottom-12">{{ 'commercialCommon.paymentMethodWithPolling.paypal.title' | transloco }}</h2>

<yat-payment-method-polling-ui
  [pollingConfiguration]="pollingConfiguration"
  [pollText]="'commercialCommon.paymentMethodWithPolling.paypal.waitingForPaypalAuthentication' | transloco"
  (cancel)="cancel()">
</yat-payment-method-polling-ui>
